<div class="container">
  <div class="left-section">
    <button id="all-shows-btn" class="action-button"> All Shows </button>
    <div class="partner-group-buttons">
    <div *ngFor="let group of partnerGroupsBtnDisplay">
      <button #tooltipButton class="partner-group-button action-button" matTooltip="{{group.name}}">
        <span class="group-name">{{group.name}}</span>
        <app-information-icon (click)="showPartnerGroupToolTip(tooltipButton, group.id)"></app-information-icon>
      </button>
      </div>
    </div>
  </div>

  <div class="right-section">
    <button id="add-show-button" class="action-button" (click)="addShow()">Add Show
      <app-plus-icon></app-plus-icon></button>
  </div>
</div>